import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { InlineToolbar } from 'content-assistance-lib/toolbars/InlineToolbar';
import { EditorState } from 'hubspot-prosemirror/pm/state';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { insertSlice } from 'hubspot-prosemirror/prosemirror/utils/documentUtils';
import useDebouncedEditorStateContext from '../../contexts/useDebouncedEditorStateContext';
import { EditorConfigContext } from '../../contexts/EditorConfigContext';
import { useContext } from 'react';
import { convertToPlaintextState } from '../../utils/plaintextUtils';
import { schema } from '../../ProsemirrorSchema';
import { findNode } from '../../utils/nodeUtils';
import { BreezeSingleStarIcon } from 'foundations-assets/icons/components/BreezeSingleStarIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export function getEditorContextPromptForAI(editorState) {
  const emailReplyHistory = findNode(editorState.doc, node => {
    return node.type === schema.nodes.emailReplyHistory;
  });
  let aiEditorState = editorState;
  if (emailReplyHistory) {
    aiEditorState = aiEditorState.apply(aiEditorState.tr.delete(emailReplyHistory.pos, emailReplyHistory.pos + emailReplyHistory.node.nodeSize));
  }
  // in case user select all (ctrl + a), `from` will be 0, and
  // insertion should be from 1 NOT 0.
  const from = Math.max(1, aiEditorState.selection.from);
  const to = aiEditorState.selection.to;
  const beforeSelection = aiEditorState.doc.textBetween(0, from, '\n');
  let sliceState = EditorState.create({
    schema
  });
  sliceState = sliceState.apply(sliceState.tr.replace(0, undefined, aiEditorState.selection.content()));
  const plainSelection = convertToPlaintextState(sliceState);
  const processedSelection = `<<${plainSelection.doc.textBetween(0, plainSelection.doc.content.size, '\n')}>>`;
  const afterSelection = aiEditorState.doc.textBetween(to, aiEditorState.doc.content.size, '\n');
  return `${beforeSelection}${processedSelection}${afterSelection}`;
}
export default function ContentAssistantHighlightButton({
  view,
  onOpenDropdown,
  pluginKey,
  usageDescription,
  selectionCommands,
  trackInteraction
}) {
  const {
    editorState,
    setEditorState
  } = useDebouncedEditorStateContext();
  const {
    CONTENT_ASSISTANT_INLINE_MENU: {
      trackOpenPopover = () => {}
    } = {}
  } = useContext(EditorConfigContext);
  const pluginState = pluginKey.getState(view.state);
  const editorContext = getEditorContextPromptForAI(editorState);
  const onClose = () => {
    view.dispatch(view.state.tr.setMeta(pluginKey, {
      widgetOpened: false,
      from: view.state.selection.from,
      to: view.state.selection.to
    }));
  };
  const onTextChange = text => {
    const html = `${text.replaceAll('\n', '<br>')}`;
    const newState = insertSlice({
      htmlBody: html,
      editorState: view.state,
      $from: editorState.selection.$from,
      $to: editorState.selection.$to
    });
    setEditorState(newState);
  };
  return /*#__PURE__*/_jsx(Popover, {
    open: pluginState && pluginState.widgetOpened,
    onOpenChange: onOpenDropdown,
    use: 'unstyled',
    placement: "bottom right",
    "data-test-id": 'content-assistant-highlight-popover',
    content: {
      body: /*#__PURE__*/_jsx(InlineToolbar, {
        selectionCommands: selectionCommands,
        onClosePopover: onClose,
        onTextChange: onTextChange,
        editorContext: editorContext,
        usageDescription: usageDescription,
        trackInteraction: trackInteraction
      })
    },
    children: pluginState && pluginState.widgetOpened ? /*#__PURE__*/_jsx("span", {}) : /*#__PURE__*/_jsx(IconButton, {
      shape: "circle",
      placement: "right",
      size: "small",
      onClick: () => {
        if (trackOpenPopover) {
          trackOpenPopover();
        }
        onOpenDropdown();
      },
      "data-test-id": 'content-assistant-highlight-trigger-button',
      children: /*#__PURE__*/_jsx(BreezeSingleStarIcon, {})
    })
  });
}